import { useRemoveModal } from '@/shared/hooks/use-remove-sidebar';
import { Toast } from '@/shared/ui/toast/toast';
import { Configurator } from '@/widgets/configurator';
import styles from './index.module.css';
import { LocalizationProvider } from './store/localization';

export const App = () => {
	useRemoveModal();

	return (
		<LocalizationProvider>
			<div className={styles.app}>
				<Configurator />
				<Toast />
			</div>
		</LocalizationProvider>
	);
};
